import image1 from "../assets/image/20211007_120244.jpg";
import { FaHouseDamage, FaTrash, FaRegEdit, FaMapMarkerAlt } from "react-icons/fa";

export default function AttractionItem({information}){
    return <div className="panel1 m-3" style={{maxWidth:'300px'}}>   <div className="item_panel1 card" style={{ borderRadius: "12px" }}>
    <a className="item_panel_head1 card-header" href="#" style={{ background: "#303481", borderRadius: "8px" }}>
      <a style={{ color: "white" }}>{information.title}</a>
    </a>
    <div className="item_panel_body1 card-body">
      <a href="#">
        <img className="img-responsive" src={information.mainpic == "" ? image1 : "http://mvc.dade24.ir/" + information.mainpic} alt="mabad_hendoa"  style={{width:'100%'}}/>
      </a>
      <div className="tozihat d-flex" dir="rtl" style={{ textAlign: "right", fontSize: "12px", marginTop: "10px" }}>
        <span className="">
          <FaMapMarkerAlt />
        </span>
        <p className="font-regular ms-2">
          <strong>مکان:</strong>
          {/* {nameCities2.label} */}
          <br />
          <div>
            <strong>شاخصه:</strong>

            <div
              style={{
                width: "100%",
                height: "60px",
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: "3",
                WebkitBoxOrient: "vertical",
              }}
            >
              <p style={{ fontSize: "13px" }}>{information.description}</p>
            </div>
          </div>
        </p>
      </div>

    
    </div>
    <a className="item_panel_footer1 card-footer" href="#" style={{ background: "#303481", color: "white", textAlign: "center", borderRadius: "8px" }}>
      نوع جاذبه:
      <a style={{ color: "white" }}> دیدنی های سراسر دنیا </a>
    </a>
  </div></div>
}